import { Link } from "react-router-dom";

const INSPIRATION_ITEMS = [
  {
    title: "Bryllup",
    description: "Skriv den perfekte bryllupstale",
    image: "/brand/moods/01-bryllup.png",
    href: "/blog/bryllupstale-guide",
  },
  {
    title: "Konfirmation",
    description: "Hjertelig tale til konfirmanden",
    image: "/brand/moods/02-konfirmation.png",
    href: "/blog/konfirmationstale-guide",
  },
  {
    title: "Rund fødselsdag",
    description: "Hyldest til 40, 50, 60 år eller mere",
    image: "/brand/moods/03-rund-foedselsdag.png",
    href: "/blog/foedselsdagstale-tips",
  },
  {
    title: "Student",
    description: "Studentertale fra forældre",
    image: "/brand/moods/04-studentertale.png",
    href: "/blog/studentertale-foraeldre-guide",
  },
];

export default function InspirationSection() {
  return (
    <section className="py-12 md:py-20 bg-muted/30" data-testid="inspiration-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-secondary font-medium text-sm uppercase tracking-wider">
            Inspiration
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-5xl font-bold text-primary mt-2">
            Find tonen til din anledning
          </h2>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto text-sm md:text-base">
            Læs vores guides — eller spring direkte til formularen og lad AI'en gøre arbejdet
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {INSPIRATION_ITEMS.map((item) => (
            <Link
              key={item.title}
              to={item.href}
              className="group block rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 bg-white"
              data-testid={`inspiration-${item.title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="aspect-square relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-primary/10 to-transparent" />
                <div className="absolute bottom-3 left-3 right-3 md:bottom-4 md:left-4 md:right-4 text-white">
                  <h3 className="font-heading text-lg md:text-2xl font-bold drop-shadow-lg">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm opacity-90 hidden md:block mt-1 drop-shadow">
                    {item.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/tale"
            className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all"
            data-testid="inspiration-cta"
          >
            Start din tale nu
          </Link>
        </div>
      </div>
    </section>
  );
}
